import { createFileRoute } from '@tanstack/react-router';
import { withModalOutlet } from '../-withModalOutlet';
import Settings from '../../../administration/src/components/MetaSites/MetaSiteDetails/Settings';

export const Route = createFileRoute('/_secured/administration/meta-sites/$metaSiteId/settings/$page/$limit')({
  component: withModalOutlet(Settings),
});
